// extracted by mini-css-extract-plugin
export default {"hubspot":"services_hubspot__YIfRj","salesforce":"services_salesforce__CKU3a","zoho":"services_zoho__++Eao","dynamics":"services_dynamics__HBJkL"};